/**
 * GLM 쿼터 위젯 API — GET /v1/internal/glm-quota
 *
 * 응답 (BE가 glm_quota_check.py subprocess 실행, 30분 캐시):
 * { now_kst, limits: [{ type, percentage, remaining_pct, next_reset_kst, hours_until_reset }] }
 * - TOKENS_LIMIT: 5시간 롤링 윈도우 남은 토큰
 * - TIME_LIMIT: 월간 시간 한도
 */
import { apiClient } from "./client";

export interface GlmQuotaLimitVO {
  type: string;
  percentage: number;
  remaining_pct: number;
  next_reset_kst: string;
  hours_until_reset: number;
}

export interface GlmQuotaVO {
  now_kst: string;
  limits: GlmQuotaLimitVO[];
}

export const glmQuotaApi = {
  getQuota: () => apiClient.get<GlmQuotaVO>("/v1/internal/glm-quota"),
};
